import React from "react";
import Image from "../../components/image";
import { asset } from "../../helpers/dom.helper";
import {
  FacebookShareButton,
  LineShareButton,
} from "react-share";
import { useLocation} from "react-router-dom";


function ShareBtn(props) {
  const webUrlToShare = 'https://lussopack.com' + useLocation().pathname;  
  
  return (
    <>
          <div className="shareContainer">
              <p className="refLink">Reference : 
                {
                  props.refLink?.map((link, index)=> {
                    let linkCut = link;
                    return <div key={index}><a href={`${link}`} target="_blank"  rel="noopener noreferrer">{" "}{linkCut}</a><br /></div>
                  })
                }
              </p>
              <div className="d-flex flex-row">
              <p className="share">SHARE: </p>
              <FacebookShareButton url={webUrlToShare}>
                <Image
                  src={asset("/images/packagingBlog/desktop/shareFacebook.svg")}
                  alt="Luxury-Packaging-Market"
                  className="mr-2"
                  width="40"
                  height="40"
                />
              </FacebookShareButton>
              <LineShareButton url={webUrlToShare}>
                <Image
                  src={asset("/images/packagingBlog/desktop/shareLine.svg")}
                  alt="Luxury-Packaging-Market"
                  width="40"
                  height="40"
                />
              </LineShareButton>
              </div>
            </div>

    </>
  );
}

export default ShareBtn;
